export const HotelOption = {
  name: 'hotel',
  type: 'STAY',
  label: 'Add a hotel',
  id: 'add-a-hotel-checkbox'
} as const

export const FlightOption = {
  name: 'flight',
  type: 'FLY',
  label: 'Add a flight',
  id: 'add-a-flight-checkbox'
} as const

export const CarOption = {
  name: 'car',
  type: 'DRIVE',
  label: 'Add a car',
  id: 'add-a-car-checkbox'
} as const
